var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15094_57934)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15094_57934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85702 0.192505C7.5543 0.193465 6.49974 1.25066 6.5007 2.55363C6.49974 3.85634 7.55502 4.91378 8.85798 4.91474H11.2153V2.55458C11.2162 1.25186 10.1609 0.194425 8.85702 0.192505ZM8.85702 6.48987H2.5731C1.27038 6.49083 0.214863 7.54803 0.215823 8.85099C0.213903 10.1537 1.26918 11.2111 2.57214 11.2131H8.85702C10.1597 11.2121 11.2153 10.1549 11.2143 8.85194C11.2153 7.54826 10.16 6.49083 8.85702 6.48987Z",
    fill: "#44C0EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7836 8.85074C23.7846 7.54802 22.7293 6.49058 21.4264 6.48962C20.1236 6.49058 19.0681 7.54778 19.0691 8.85074V11.2128H21.4264C22.7291 11.2119 23.7846 10.1547 23.7836 8.85074ZM17.4988 8.85074V2.55338C17.4997 1.25162 16.4454 0.194181 15.1424 0.192261C13.8397 0.193221 12.7842 1.25042 12.7852 2.55338V8.85074C12.7832 10.1535 13.8385 11.2109 15.1415 11.2128C16.4442 11.2119 17.4997 10.1547 17.4988 8.85074Z",
    fill: "#3AB07C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1415 23.8075C16.4442 23.8066 17.4997 22.7494 17.4987 21.4464C17.4997 20.1437 16.4444 19.0863 15.1415 19.0853H12.7842V21.4464C12.7832 22.7482 13.8385 23.8056 15.1415 23.8075ZM15.1415 17.5092H21.4263C22.7291 17.5083 23.7846 16.4511 23.7836 15.1481C23.7855 13.8454 22.7303 12.7879 21.4273 12.786H15.1424C13.8397 12.787 12.7842 13.8442 12.7851 15.1471C12.7842 16.4508 13.8385 17.5083 15.1415 17.5092Z",
    fill: "#ECB22C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.215821 15.1484C0.214861 16.4511 1.27014 17.5085 2.5731 17.5095C3.87582 17.5085 4.93134 16.4513 4.93038 15.1484V12.7872H2.5731C1.27038 12.7882 0.214861 13.8454 0.215821 15.1484ZM6.5007 15.1484V21.4457C6.49878 22.7484 7.55406 23.8059 8.85702 23.8078C10.1597 23.8068 11.2153 22.7496 11.2143 21.4467V15.1503C11.2162 13.8476 10.1609 12.7901 8.85798 12.7882C7.5543 12.7882 6.49974 13.8454 6.5007 15.1484Z",
    fill: "#E11F5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15094_57934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15094_57934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.cec9d27cde9d553bb8ee6a6231382349.svg";
export { ForwardRef as ReactComponent };